// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_commentaries-module__commentaries--3MPxc{overflow:hidden}\n", ""]);
// Exports
exports.locals = {
	"commentaries": "lawyer_commentaries-module__commentaries--3MPxc"
};
module.exports = exports;
